import type { EmployeeSummary } from '../types/models';

/**
 * 雇用形態の並び順: 正社員 → その他 → パート/非常勤
 */
const employmentOrder = (et: string | null | undefined): number => {
  const v = et ?? '';
  if (v === '正社員') return 0;
  if (v === 'その他') return 1;
  return 2;
};

/**
 * 職種の並び順: 介護 → 看護 → 調理/厨房 → それ以外
 */
const jobOrder = (jt: string | null | undefined): number => {
  const v = jt ?? '';
  if (v.includes('介護')) return 0;
  if (v.includes('看護')) return 1;
  if (v.includes('調理') || v.includes('厨房')) return 2;
  return 3;
};

/**
 * 従業員配列を共通ルールでソート（非破壊）
 *   1. 雇用形態（正社員 → その他 → パート/非常勤）
 *   2. 職種（介護 → 看護 → 調理 → 他）
 *   3. 氏名（五十音）
 */
export function sortEmployeesDefault<T extends Pick<EmployeeSummary, 'employmentType' | 'jobType' | 'name'>>(
  employees: T[]
): T[] {
  return [...employees].sort((a, b) => {
    const eo = employmentOrder(a.employmentType) - employmentOrder(b.employmentType);
    if (eo !== 0) return eo;
    const jo = jobOrder(a.jobType) - jobOrder(b.jobType);
    if (jo !== 0) return jo;
    return (a.name ?? '').localeCompare(b.name ?? '');
  });
}
